import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ScrBaseComponent, LabelValuePair } from "../../../base.component";
import { Table } from 'primeng/table';
import { ConfirmationService, SortEvent } from 'primeng/api';
import { TableColumn } from 'src/app/models/table-columns';
import { Partner } from 'src/app/models/partner.model';
import { PartnerService, VettedEntityResultsResponse } from 'src/app/services/partner.service';
import { BadgeService, ReportsService, ScrBaseResponse } from "../../../../services";
import { DialogEvent, DynamicDialogComponent } from "../../../custom-controls/dynamic-dialog/dynamic-dialog.component";
import { VetResultsDialogComponent } from "../../../../shared/vet-results-dialog/vet-results-dialog.component";
import { HttpErrorResponse } from "@angular/common/http";
import { DialogName, PartnerType } from "../../../../models/constants";
import { pickBy } from "lodash-es";
import { ActivatedRoute } from "@angular/router";
import { MultiSelect } from "primeng/multiselect";

@Component({
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss'],
})
export class PartnerListComponent extends ScrBaseComponent implements OnInit {

  partners: Partner[] = [];
  filteredPartners: Partner[] = [];
  addPartnerBool = false;
  updatePartnerBool = false;
  partnerToEditObj!: Partner;
  allScIds: number[] = [];
  scIdCount? = 0;
  filtersVisible = false;
  vetResults!: Partial<VettedEntityResultsResponse>;
  public checked = false;
  @ViewChild('globalSearch', { static: false }) globalSearch!: ElementRef;
  @ViewChild('tt', { static: false }) tt!: Table;
  @ViewChild('multiVetStatus') multiVetStatus!: MultiSelect;
  //public searchInput = '';
  public brandClientInput = '';
  public feinInput = '';
  public partnerType = PartnerType.Brand;
  public partnerTypeWithSpace: string = PartnerType.Brand;
  public partnerTypeShort: string = PartnerType.Brand;
  allVetStatus: LabelValuePair[] = [];

  @ViewChild(DynamicDialogComponent) dd!: DynamicDialogComponent;

  tableColumn: TableColumn[] = [
    { field: 'partnerId',width:'25', sort: false },
    { field: 'company', width: '21', sort: true },
    { field: 'dba', width: '10' },
    { field: 'fein', width: '13' },
    { field: 'vetStatus', width: '20', sort: true },
    { field: 'updateTime', header: 'Last Updated', width: '22', sort: true },
    { field: 'action', width: '5' }
  ];

  constructor(
    private route: ActivatedRoute,
    private partnerService: PartnerService,
    private badgeService: BadgeService,
    private reportsService: ReportsService,
    private confirmationService: ConfirmationService,) {
    super();
  }


  ngOnInit(): void {
    this.partnerType = this.route.snapshot.data.partnerType ?? PartnerType.Brand;
     this.allVetStatus = [
      { label: 'Incomplete', value: 'Incomplete' },
      { label: 'Pending', value: 'Pending' },
      { label: 'Pending 2FA PIN sent', value: 'Pending 2FA PIN sent' },
      { label: 'Pending Contact email verified', value: 'Pending Contact email verified' },
      { label: 'Successful', value: 'Successful' },
      { label: 'Unsuccessful', value: 'Unsuccessful' }
    ];
    if (this.partnerType === PartnerType.Brand) {
      this.tableColumn[0].localizationKey = 'brandId';
      this.tableColumn[0].width = '5';
      this.tableColumn[1].localizationKey = 'brandClient';
      this.partnerTypeWithSpace = 'Brand Client';
      this.partnerTypeShort = 'Brand';
    }
    else {
      this.tableColumn[0].localizationKey = 'contentProviderId';
      this.tableColumn[0].width = '20';
      this.tableColumn[1].localizationKey = 'contentProvider';
      this.partnerTypeWithSpace = 'Content Provider';
      this.partnerTypeShort = 'Content Provider';
    }
    this.localizeTableColumns(this.tableColumn);
    this.retrievePartners();
  }


  retrievePartners(successMessage?: string, successMessageCode?: string, itemToExpand?: string | number) {
    this.clearMessages();
    window.scrollTo(0, 0);
    this.observe(this.partnerService.retrievePartnerListDetails(this.partnerType), res => {
      if (successMessageCode) {
        this.displayLocalizedSuccess(successMessageCode);
      }
      else if (successMessage) {
        this.displaySuccess(successMessage, true);
      }
      this.partners = [];
      this.filteredPartners = [];

      if (res.partnerList.badgeCount !== undefined) {
        this.badgeService.updateLocally(data => {
          if (this.partnerType === PartnerType.Brand) {
            data.brandCount = res.partnerList.badgeCount;
          }
          else {
            data.contentProviderCount = res.partnerList.badgeCount;
          }
          return data;
        });
      }

      if (res.partnerList.partners) {
        res.partnerList.partners.forEach(p=> {
          p.vetStatusAndReason = p.vetStatusReason ? `${p.vetStatus} ${p.vetStatusReason}` : p.vetStatus;
        });
      }

      this.partners = res.partnerList.partners;
      this.filteredPartners = [...this.partners];

      if (itemToExpand) {
        const key = `${itemToExpand}`;
        if (this.tt.expandedRowKeys[key] === undefined) {
          this.tt.expandedRowKeys[key] = true;
        }
      }
      return false; // we will handle the messages.
    });
  }


  protected override hideChildren(): void {
    this.clearMessages();
    this.addPartnerBool = false;
    this.updatePartnerBool = false;

  }




  displayAddPartner() {
    this.clearMessages();
    this.addPartnerBool = true;
  }

  editPartner(partner: Partner) {
    this.clearMessages();
   

    this.brandClientInput='';
    this.feinInput='';

    // go get the vetting results then display the dialog.
    this.observe(this.partnerService.retrievePartner(partner.partnerId), (rsp => {
      this.updatePartnerBool = true;
      this.partnerToEditObj = rsp.partner;
      this.partnerToEditObj.scIds = rsp.scIds;
      this.scIdCount = rsp.scIdCount;
      this.filtersVisible = false;
      return false;
    }));
  }

  getPreDeletePartnerData(partner: Partner) {
    
    this.clearMessages();

    this.observe(this.partnerService.getPreDeletePartnerData(partner), res => {
      if (res.status === 'success') {
      let message, header;
      if (partner.partnerType === 'Brand'){
      header = 'Delete Brand Client';
      message = `You are about to delete brand client ${partner.company} (Brand ID ${partner.partnerId}).`;
      if (res.preDeletePartnerData.partnerIsUnassociated){
        message = message+`<br><br>${partner.company} is not currently associated with any short code leases.`;
      }

      if (res.preDeletePartnerData.cscsUnassociatedToOtherPartners.length > 0 ) {
        message = message+`<br><br>${partner.company} is associated with the following short code(s) with no other associated brand client: ${res.preDeletePartnerData.cscsUnassociatedToOtherPartners}. 
        Please use the Edit Application function to associate a successfully vetted brand client with the short code(s) listed, so the lease remains valid and they can renew without disruption.`;
      }
      
      if (res.preDeletePartnerData.cscsAssociatedToOtherPartners.length > 0 ) {
        message = message+`<br><br>`+`${partner.company} is associated with the following short code(s) with another associated brand client: ${res.preDeletePartnerData.cscsAssociatedToOtherPartners}.`;
      }

      message = message+`<br><br>`+`Please click the OK button to permanently delete ${partner.company} (Brand ID ${partner.partnerId})`;
      if (!res.preDeletePartnerData.partnerIsUnassociated ) 
        message = message+` and its association with any short code(s)`;
      message = message+`.`;
    } else {
      header = 'Delete Content Provider';
      message = `You are about to delete content provider ${partner.company} (Content Provider ID ${partner.partnerId}).`;
      if (res.preDeletePartnerData.partnerIsUnassociated){
        message = message+`<br><br>${partner.company} is not currently associated with any short code leases.`;
      }else {

        message = message+`<br><br>${partner.company} is currently associated with ${res.preDeletePartnerData.numberOfAssociatedCscs} short code lease(s). Please use the Short Code List Report to view which short codes were associated with this content provider, then use the Edit Application function to associate a successfully vetted content provider with those short codes. This way, the lease remains valid and any affected short codes can renew without disruption.`;
      }

      message = message+`<br><br>`+`Please click the OK button to permanently delete ${partner.company} (Content Provider ID ${partner.partnerId})`;
      if (!res.preDeletePartnerData.partnerIsUnassociated ) 
        message = message+` and its association with any short code(s)`;
      message = message+`.`;
    }
      this.confirmationService.confirm({
      
      header: header,
      key: 'confirmDelete',
      message: message,
      accept: () => {
        this.observe(this.partnerService.deletePartner(partner), res => {
          if (res.status === 'success') {
            let successMessage: string | undefined = undefined;
            if (res.messages && res.messages.length > 0) {
              successMessage = res.messages[0].message;
            }
            if (this.brandClientInput || this.feinInput) {
            
              this.tt.filterGlobal(undefined, 'contains');
            }
            this.brandClientInput='';
            this.feinInput ='';
            this.filtersVisible = false;
            this.retrievePartners(successMessage);
          }
          else if (res.messages) {
            this.processScrErrorResponse(res, true);
          }
          return false;
        });
      }
    });
        /*let successMessage: string | undefined = undefined;
        if (res.messages && res.messages.length > 0) {
          successMessage = res.messages[0].message;
        }
        this.retrievePartners(successMessage);*/
      }
      else if (res.messages) {
        this.processScrErrorResponse(res, true);
      }
      return false;
    });

    /*this.confirmationService.confirm({
      message,
      header: 'Confirm Removal of ' + partner.partnerType,
      key: 'confirmDelete',
      accept: () => {
        this.observe(this.partnerService.deletePartner(partner), res => {
          if (res.status === 'success') {
            let successMessage: string | undefined = undefined;
            if (res.messages && res.messages.length > 0) {
              successMessage = res.messages[0].message;
            }
            this.retrievePartners(successMessage);
          }
          else if (res.messages) {
            this.processScrErrorResponse(res, true);
          }
          return false;
        });
      }
    });*/
  }



  protected override reloadList(message?: string, messageCode?: string, value?: number | string): void {
    this.retrievePartners(message, messageCode, value);
  }


  viewVetResults(event: MouseEvent, partner: Partner): void {
    this.clearMessages();
    event.preventDefault();
    this.observe(this.partnerService.getVettingResults(partner.partnerId), (rsp => {
      if (rsp.messages && rsp.messages.length > 0 && rsp.messages[0].code !== '2100') {
        // display the message instead of showing the dialog.
        this.displayInfoMessage(rsp.messages[0].message);
        return false;
      }
      else {
        // fetch the details first, then show the dialog.
        const data = pickBy(rsp, (v, k) => {
          return (k !== 'messages' && k !== 'status' && k !== 'errorCode');
        });
        this.dd.show(VetResultsDialogComponent, {
          ...data,
          entityName: partner.company,
          entityType: partner.partnerType
        });
        return false;
      }
    }));
  }

  onDialogComplete(e: DialogEvent): void {

    if (e.error instanceof HttpErrorResponse) {
      this.doHttpError(e.error);
    }
    else if (e.error instanceof ScrBaseResponse) {
      this.processScrErrorResponse(e.error);
    }

    switch (e.name) {
      case DialogName.VetResults:
        // anything to do ?
        break;
      default:
        console.warn('unexpected dialog ' + e.name);
    }
  }

  downloadCpReport(): void {
    // Fix this to point at the new report.
    this.reportsService.downloadOriginalShortCodeListWithContentProviders().subscribe({
      next: (res) => {
        this.reportsService.processBlobResponseDownload(res);
      },
      error: (error: HttpErrorResponse) => {
        this.processHttpScrErrorResponse(error); this.jumpToTop();
      }
    });
  }

  toggleFilter(): void {
    this.filtersVisible = !this.filtersVisible;
  }

  clearFilter() {
    this.tt.clearFilterValues();
    this.tt.filterGlobal(undefined, 'contains');
    this.multiVetStatus.clear({} as Event);
  }
  onSlide(): void {
    if (this.checked) {
      this.tt.globalFilterFields = [];
      this.tt.globalFilterFields?.push('fein');
      console.log('selected fein slider');
      this.tt.filterGlobal('', 'contains');
    }
    if (!this.checked) {
      this.tt.globalFilterFields?.pop();
      this.tt.globalFilterFields?.push('partnerId');
      this.tt.globalFilterFields?.push('dba');
      this.tt.globalFilterFields?.push('company');
      console.log('selected brand client/dba slider');
      this.tt.filterGlobal('', 'contains');
    }
  }

  customSort(event: SortEvent) {
    if (this.tt) {
      this.tt.expandedRowKeys = {};
    }

    if (!event.data) {
      return;
    }

    const data = event.data as Partner[];
    data.sort((a, b) => {
      let rv = 0;
      if (event.field === 'vetStatus') {
        rv = a.vetStatus.localeCompare(b.vetStatus);
        if (rv === 0) {
          if (!a.vetStatusReason && b.vetStatusReason) {
            rv = -1;
          }
          else if (!b.vetStatusReason && a.vetStatusReason) {
            rv = 1;
          }
          else if (a.vetStatusReason && b.vetStatusReason) {
            rv = a.vetStatusReason.localeCompare(b.vetStatusReason);
          }
        }
      } else if (event.field === 'company') {
        rv = a.company.localeCompare(b.company);
      }  else if (event.field === 'updateTime') {
        if (!a.updateTime) return -1;
        if (!b.updateTime) return 1;

        const t1 = new Date(a.updateTime).getTime();
        const t2 = new Date(b.updateTime).getTime();
        rv = t1 < t2 ? -1 : t1 === t2 ? 0 : 1;
      }

      if (event.order) {
        rv *= event.order;
      }

      return rv;
    });
  }


}